import * as React from 'react';

import type { SessionState } from '@/features/ChatBotV2/types';
import { isBotMessageState } from '@/features/ChatBotV2/types';
import { Events, useCustomEventDispatch } from '@/hooks/customEvent';

import { useReportFeedId, useReportPage } from './useReport';

export const useSyncReportChat = ({
  enabled,
  currentFeedOrDocumentId,
  sessionState,
}: useSyncReportChatType) => {
  const { reportFeedId } = useReportFeedId();
  const { reportPageMatch } = useReportPage();
  const dispatchReportMessageComplete = useCustomEventDispatch<SessionState>(
    Events.REPORT_CHAT_ANSWER_COMPLETE
  );

  React.useEffect(() => {
    if (
      enabled &&
      reportPageMatch &&
      currentFeedOrDocumentId === reportFeedId &&
      sessionState.messages.length > 0
    ) {
      const lastMessage =
        sessionState.messages[sessionState.messages.length - 1];

      if (isBotMessageState(lastMessage)) {
        if (!lastMessage.streamingAnswer && lastMessage.data) {
          dispatchReportMessageComplete(sessionState);
        }
      }
    }
  }, [
    reportPageMatch,
    reportFeedId,
    enabled,
    currentFeedOrDocumentId,
    sessionState,
    dispatchReportMessageComplete,
  ]);
};

type useSyncReportChatType = {
  enabled: boolean;
  currentFeedOrDocumentId: string;
  sessionState: SessionState;
};
